const state = {
    editorError: null,
    user: null
};

const mutations = {
    'SET_EDITOR_ERROR'(state, error) {
        state.editorError = error;
    },
    'SET_USER'(state, user) {
        state.user = user;
    }
};

const actions = {
    setEditorError: ({ commit }, error) => {
        error.occuredOn = Date.now();
        commit('SET_EDITOR_ERROR', error);
    },
    setUser: ({ commit }, user) => commit('SET_USER', user)
};

const getters = {
    editorError: state => state.editorError,
    user: state => state.user,
};

export default {
    state,
    mutations,
    actions,
    getters
};
